  (() => {
    if (document.documentElement.dataset.seoShopMegaReady === 'true') return;
    document.documentElement.dataset.seoShopMegaReady = 'true';

    const loadDeferredMenuImages = (root, priority = 'high') => {
      if (!root) return;

      root.querySelectorAll('img[data-seo-deferred-src]').forEach((image) => {
        const revealImage = () => image.classList.add('is-loaded');
        image.addEventListener('load', revealImage, { once: true });
        image.loading = 'eager';
        image.fetchPriority = priority;

        if (image.dataset.seoDeferredSrcset) {
          image.srcset = image.dataset.seoDeferredSrcset;
        }
        image.src = image.dataset.seoDeferredSrc;
        delete image.dataset.seoDeferredSrc;
        delete image.dataset.seoDeferredSrcset;

        if (image.complete && image.naturalWidth > 0) revealImage();
      });
    };

    const desktopMegaRoot = document.querySelector('[data-seo-mega-root]');
    let warmDesktopPrimaryImages = () => {};
    if (desktopMegaRoot) {
      const warmPrimaryImages = () => {
        loadDeferredMenuImages(desktopMegaRoot.querySelector('[data-seo-mega-panel="shop"]'));
      };
      warmDesktopPrimaryImages = warmPrimaryImages;
      const desktopMegaTrigger = document.querySelector(
        `[data-meganav-trigger][data-meganav-handle="${desktopMegaRoot.dataset.menuHandle}"]`
      );
      const desktopCollectionsTrigger = desktopMegaRoot.querySelector('[data-seo-mega-target="collections"]');

      desktopMegaTrigger?.addEventListener('pointerenter', warmPrimaryImages, { once: true, passive: true });
      desktopMegaTrigger?.addEventListener('pointerdown', warmPrimaryImages, { once: true, passive: true });
      desktopMegaTrigger?.addEventListener('focus', warmPrimaryImages, { once: true });
      desktopCollectionsTrigger?.addEventListener('pointerenter', () => loadDeferredMenuImages(desktopMegaRoot), { once: true, passive: true });
      desktopCollectionsTrigger?.addEventListener('pointerdown', () => loadDeferredMenuImages(desktopMegaRoot), { once: true, passive: true });
      desktopCollectionsTrigger?.addEventListener('focus', () => loadDeferredMenuImages(desktopMegaRoot), { once: true });
    }

    const mobileMenuButton = document.querySelector('[data-js-menu-button]');
    const loadMobilePrimaryImages = () => {
      document.querySelectorAll('[data-seo-mobile-mega-root]').forEach((root) => {
        loadDeferredMenuImages(root.querySelector('[data-seo-mobile-panel="shop"]'));
      });
    };
    mobileMenuButton?.addEventListener('pointerdown', loadMobilePrimaryImages, { once: true, passive: true });
    mobileMenuButton?.addEventListener('focus', loadMobilePrimaryImages, { once: true });
    if (document.body.getAttribute('mobile-menu-open') === 'true') {
      loadMobilePrimaryImages();
    }

    const warmPrimaryMenuImagesWhenIdle = () => {
      const warmImages = () => {
        if (window.matchMedia('(min-width: 960px)').matches) {
          loadDeferredMenuImages(
            desktopMegaRoot?.querySelector('[data-seo-mega-panel="shop"]'),
            'low'
          );
        } else {
          document.querySelectorAll('[data-seo-mobile-mega-root]').forEach((root) => {
            loadDeferredMenuImages(root.querySelector('[data-seo-mobile-panel="shop"]'), 'low');
          });
        }
      };

      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(warmImages, { timeout: 2500 });
      } else {
        window.setTimeout(warmImages, 600);
      }
    };

    if (document.readyState === 'complete') {
      warmPrimaryMenuImagesWhenIdle();
    } else {
      window.addEventListener('load', warmPrimaryMenuImagesWhenIdle, { once: true });
    }

    const switchPanel = (root, panelSelector, target, buttonSelector) => {
      root.querySelectorAll(panelSelector).forEach((panel) => {
        panel.hidden = panel.dataset.seoMegaPanel !== target && panel.dataset.seoMobilePanel !== target;
      });

      root.querySelectorAll(buttonSelector).forEach((button) => {
        const controlsTarget = button.getAttribute('aria-controls');
        const controlsPanel = controlsTarget ? document.getElementById(controlsTarget) : null;
        button.setAttribute('aria-expanded', String(Boolean(controlsPanel && !controlsPanel.hidden)));
      });
    };

    const syncMobileDrawerHeight = (root) => {
      const childMenu = root && root.querySelector('.drawer-menu__list--sub');
      const drawerMain = root && root.closest('[data-main]');
      if (!childMenu || !drawerMain) return;

      const update = () => {
        drawerMain.style.height = `${Math.ceil(childMenu.scrollHeight) + 8}px`;
      };

      update();
      window.requestAnimationFrame(() => window.requestAnimationFrame(update));

      childMenu.querySelectorAll('img').forEach((image) => {
        if (!image.complete) image.addEventListener('load', update, { once: true });
      });
    };

    document.addEventListener('click', (event) => {
      const delegatedSearchClear = event.target.closest('[data-drawer-search-clear]');
      if (delegatedSearchClear) {
        const delegatedSearch = delegatedSearchClear.closest('[data-drawer-search]');
        const delegatedInput = delegatedSearch && delegatedSearch.querySelector('[data-drawer-search-input]');
        if (delegatedInput) {
          delegatedInput.value = '';
          delegatedInput.dispatchEvent(new Event('input', { bubbles: true }));
          delegatedInput.blur();
        }
      }

      const desktopButton = event.target.closest('[data-seo-mega-target]');
      if (desktopButton) {
        const root = desktopButton.closest('[data-seo-mega-root]');
        if (root) {
          if (desktopButton.dataset.seoMegaTarget === 'collections') loadDeferredMenuImages(root);
          switchPanel(root, '[data-seo-mega-panel]', desktopButton.dataset.seoMegaTarget, '[data-seo-mega-target]');
        }
      }

      const mobileButton = event.target.closest('[data-seo-mobile-target]');
      if (mobileButton) {
        const root = mobileButton.closest('[data-seo-mobile-mega-root]');
        if (root) {
          const target = mobileButton.dataset.seoMobileTarget;
          const scrollContainer = root.closest('.drawer-menu__contents');

          if (scrollContainer && target === 'collections') {
            root.dataset.seoShopScroll = String(scrollContainer.scrollTop);
          }

          root.classList.add('seo-mobile-transitioning');
          window.clearTimeout(root.seoMobileTransitionTimer);
          root.seoMobileTransitionTimer = window.setTimeout(() => {
            switchPanel(root, '[data-seo-mobile-panel]', target, '[data-seo-mobile-target]');

            syncMobileDrawerHeight(root);

            if (scrollContainer) {
              const nextScroll = target === 'shop' ? Number(root.dataset.seoShopScroll || 0) : 0;
              scrollContainer.scrollTo({ top: nextScroll, behavior: 'auto' });
            }

            root.classList.remove('seo-mobile-transitioning');
            const activePanel = root.querySelector(`[data-seo-mobile-panel="${target}"]`);
            const focusTarget = activePanel && activePanel.querySelector('[data-seo-mobile-target], a, button');
            if (focusTarget) focusTarget.focus({ preventScroll: true });
          }, 120);
        }
      }
    });

    document.querySelectorAll('[data-drawer-search]').forEach((search) => {
      const form = search.querySelector('form');
      const input = search.querySelector('[data-drawer-search-input]');
      const clearButton = search.querySelector('[data-drawer-search-clear]');
      const results = search.querySelector('[data-drawer-search-results]');
      const predictiveSearchUrl = search.dataset.predictiveSearchUrl;
      if (!form || !input || !clearButton || !results || !predictiveSearchUrl) return;

      let searchTimer;
      let searchRequest;
      const clearResults = () => {
        results.hidden = true;
        results.replaceChildren();
        search.classList.remove('is-searching');
      };

      const syncClearButton = () => {
        const hasValue = input.value.length > 0;
        form.classList.toggle('has-value', hasValue);
        clearButton.hidden = !hasValue;
      };

      input.addEventListener('input', () => {
        syncClearButton();
        window.clearTimeout(searchTimer);
        if (searchRequest) searchRequest.abort();
        const term = input.value.trim();
        if (term.length < 2) {
          clearResults();
          return;
        }

        searchTimer = window.setTimeout(async () => {
          searchRequest = new AbortController();
          const params = new URLSearchParams({
            q: term,
            section_id: 'predictive-search',
            'resources[type]': 'product,query',
            'resources[limit]': '4',
            'resources[options][unavailable_products]': 'last'
          });

          try {
            const response = await fetch(`${predictiveSearchUrl}?${params}`, {
              signal: searchRequest.signal
            });
            if (!response.ok) throw new Error(String(response.status));
            const documentResponse = new DOMParser().parseFromString(await response.text(), 'text/html');
            const section = documentResponse.querySelector('#shopify-section-predictive-search');
            if (!section) {
              clearResults();
              return;
            }

            results.innerHTML = section.innerHTML;
            const viewAll = document.createElement('a');
            const viewAllUrl = new URL(form.action, window.location.origin);
            viewAllUrl.searchParams.set('q', term);
            viewAllUrl.searchParams.set('type', 'product,collection,page');
            viewAll.className = 'drawer-menu__search-all';
            viewAll.href = viewAllUrl.href;
            viewAll.textContent = 'View all results';
            results.appendChild(viewAll);
            results.hidden = false;
            search.classList.add('is-searching');
          } catch (error) {
            if (error.name !== 'AbortError') clearResults();
          }
        }, 180);
      });

      input.addEventListener('search', () => {
        if (!input.value) clearResults();
        syncClearButton();
      });

      syncClearButton();
    });

    document.querySelectorAll('[data-drawer-newsletter]').forEach((newsletter) => {
      const email = newsletter.querySelector('input[type="email"]');
      if (!email) return;
      const engage = () => newsletter.classList.add('is-engaged');
      email.addEventListener('focus', engage);
      email.addEventListener('input', engage);
    });

    const desktopMedia = window.matchMedia('(min-width: 960px)');
    const closeMobileMenuAtDesktop = (event) => {
      if (!event.matches) return;

      document.querySelectorAll('[data-seo-mobile-mega-root]').forEach((root) => {
        switchPanel(root, '[data-seo-mobile-panel]', 'shop', '[data-seo-mobile-target]');
      });

      if (document.body.getAttribute('mobile-menu-open') !== 'true') return;
      const menuButton = document.querySelector('[data-js-menu-button][aria-expanded="true"]');
      if (menuButton) menuButton.click();
    };

    if (desktopMedia.addEventListener) {
      desktopMedia.addEventListener('change', closeMobileMenuAtDesktop);
    } else {
      desktopMedia.addListener(closeMobileMenuAtDesktop);
    }

    closeMobileMenuAtDesktop(desktopMedia);
  })();
